;(function () {
  /* neverover — cross-cutting mobile/typography fixes. Pure JS; no Liquid edits.
       (A) WebKit font-metrics fix: helvetica-neue-world ships ascent+descent ≈ 1.91em.
           Chromium/Firefox are corrected via ascent/descent-override (nv-ui-fixes.js), but
           WebKit (ALL iOS browsers + macOS Safari) ignores those descriptors, so text there
           renders in ~2x-tall, top-heavy line boxes — the "uneven spacing everywhere on
           mobile/Safari". Fix: on WebKit only, re-declare the SAME family name from the
           device's local Helvetica Neue (same design, correct metrics, zero download).
       (B) SmartRecom (AI size recommender) mobile layout: its UI lives in a shadow root that
           page CSS can't reach, so we inject a mobile stylesheet INTO the shadow root. */
  if (window.__nvMobileFixes) return;
  window.__nvMobileFixes = true;

  /* ============================== (A) WebKit local Helvetica Neue ============================== */
  function applyLocalHN(){
    if (document.getElementById('nv-webkit-local-hn')) return;
    var faces = [
      [300, 'normal', 'HelveticaNeue-Light',      'Helvetica Neue Light'],
      [400, 'normal', 'HelveticaNeue',            'Helvetica Neue'],
      [500, 'normal', 'HelveticaNeue-Medium',     'Helvetica Neue Medium'],
      [600, 'normal', 'HelveticaNeue-Medium',     'Helvetica Neue Medium'],
      [700, 'normal', 'HelveticaNeue-Bold',       'Helvetica Neue Bold'],
      [400, 'italic', 'HelveticaNeue-Italic',     'Helvetica Neue Italic'],
      [700, 'italic', 'HelveticaNeue-BoldItalic', 'Helvetica Neue Bold Italic']
    ];
    var css = '';
    for (var i = 0; i < faces.length; i++){
      var f = faces[i];
      css += '@font-face{font-family:"helvetica-neue-world";font-style:' + f[1] + ';font-weight:' + f[0] +
             ';src:local("' + f[2] + '"),local("' + f[3] + '");}';
    }
    var st = document.createElement('style');
    st.id = 'nv-webkit-local-hn';
    st.textContent = css;
    document.head.appendChild(st);
    // nv-ui-fixes re-declares the Typekit faces asynchronously (style#nv-font-metric-fix);
    // with equal @font-face descriptors the LAST declaration wins, so keep ours last.
    new MutationObserver(function(){
      if (document.head.lastElementChild !== st) document.head.appendChild(st);
    }).observe(document.head, { childList: true });
  }
  window.__nvApplyLocalHN = applyLocalHN;            // manual hook for cross-browser testing
  if (/^Apple/.test(navigator.vendor || '')) applyLocalHN();

  /* ============================== (B) SmartRecom mobile layout ============================== */
  var SR_CSS = '@media (max-width:767px){'
    + '.smartrecom-modal-overlay{padding:12px !important;align-items:center !important;justify-content:center !important;}'
    + '.smartrecom-modal-content{flex-direction:column !important;width:100% !important;max-width:420px !important;'
    +   'height:auto !important;min-height:540px !important;max-height:88dvh !important;overflow-y:auto !important;border-radius:14px !important;}'
    + '.smartrecom-modal-content div:has(> img){display:none !important;}'                /* photo column */
    + '.smartrecom-modal-content div:has(> .smartrecom-quiz-manager){width:100% !important;height:auto !important;}'
    + '.smartrecom-quiz-manager{width:100% !important;height:auto !important;padding:18px 16px 12px !important;}'
    + '.smartrecom-quiz-content{width:100% !important;height:auto !important;min-height:0 !important;}'
    + '.smartrecom-quiz-content > div{width:100% !important;height:auto !important;}'
    + '.smartrecom-quiz-footer{position:static !important;width:100% !important;height:auto !important;'           /* sits right under the inputs */
    +   'min-height:0 !important;display:flex !important;align-items:center !important;justify-content:space-between !important;'
    +   'gap:12px !important;padding:14px 0 4px !important;}'
    + '.smartrecom-quiz-footer-left,.smartrecom-quiz-footer-right{position:static !important;width:auto !important;height:auto !important;}'
    + '.smartrecom-close-button{top:10px !important;right:10px !important;}'
    + '}';
  function injectSR(){
    var host = document.getElementById('smartrecom-portal-host');
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('#nv-smartrecom-mobile')){
      var st = document.createElement('style');
      st.id = 'nv-smartrecom-mobile';
      st.textContent = SR_CSS;
      root.appendChild(st);
    }
    return true;
  }
  if (!injectSR()){
    var mo = new MutationObserver(function(){ if (injectSR()) mo.disconnect(); });
    var boot = function(){ mo.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('DOMContentLoaded', injectSR);
  }

  /* ============================== (C2) Market-aware shipping-threshold tokens ============================== */
  /* Content (collection FAQs, rich text, announcements) writes the literal token {threshold}.
     Replace it with the CURRENT market's free-shipping threshold from the shop metafield
     custom.free_shipping_thresholds (kept fresh by the GitHub automation), formatted in the
     market's own currency — never a list of currencies. Data is injected by theme.liquid
     into script#nv-shipping-data as {"currency":"RON","thresholds":{"RON":375,...}}. */
  (function thresholdTokens(){
    function fmt(amount, cur){
      var n = String(parseFloat(amount));
      if (cur === 'RON') return n + ' lei';
      if (cur === 'EUR') return '€' + n;
      if (cur === 'USD') return '$' + n;
      if (cur === 'GBP') return '£' + n;
      return n + ' ' + cur;
    }
    function run(){
      var dataEl = document.getElementById('nv-shipping-data');
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e){ return; }
      var cur = data.currency, map = data.thresholds || {};
      var amt = map[cur];
      if (amt == null && map.EUR != null){ cur = 'EUR'; amt = map.EUR; }   // fallback market
      if (amt == null) return;
      var label = fmt(amt, cur);
      var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      var n, hits = [];
      while ((n = tw.nextNode())) if (n.nodeValue && n.nodeValue.indexOf('{threshold}') > -1) hits.push(n);
      for (var i = 0; i < hits.length; i++) hits[i].nodeValue = hits[i].nodeValue.split('{threshold}').join(label);
    }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    setTimeout(run, 1500);                                  // late-rendered sections
    document.addEventListener('shopify:section:load', function(){ setTimeout(run, 50); });
  })();

  /* ============================== (C3) Newsletter perks strip → snap slider (mobile) ============================== */
  /* Drag follows the finger 1:1; on release it smoothly snaps the nearest card's left edge
     to the strip's left padding. Cards only clip at the browser edges (wrapper is full-bleed). */
  (function perksSlider(){
    function init(){
      if (!window.matchMedia('(max-width:767px)').matches) return;
      var wrap = document.querySelector('.signup_number-wrapper');
      var strip = wrap && wrap.querySelector('.signup_number-component');
      if (!wrap || !strip || strip._nvSlider) return;
      strip._nvSlider = 1;
      // HARD full-bleed: measured in pixels (vw/transform tricks kept failing inside inset,
      // clipping ancestors). Pin the wrapper to the real viewport edges and force every
      // ancestor up to the shopify-section to overflow:visible so nothing clips mid-slide.
      function fullBleed(){
        wrap.style.setProperty('transform', 'none', 'important');
        wrap.style.setProperty('right', 'auto', 'important');
        var pl = wrap.parentElement.getBoundingClientRect().left + window.scrollX * 0;
        wrap.style.setProperty('left', (-pl) + 'px', 'important');
        wrap.style.setProperty('width', window.innerWidth + 'px', 'important');
        wrap.style.setProperty('max-width', 'none', 'important');
        var n = wrap.parentElement;
        while (n && n !== document.body){
          if (getComputedStyle(n).overflow !== 'visible' || getComputedStyle(n).overflowX !== 'visible'){
            n.style.setProperty('overflow', 'visible', 'important');
          }
          if (/shopify-section/.test(n.className || '')) break;
          n = n.parentElement;
        }
      }
      fullBleed();
      window.addEventListener('resize', fullBleed, { passive: true });
      var x = 0, startX = 0, baseX = 0, dragging = false;
      var PAD = 16;
      function maxShift(){ return Math.max(0, strip.scrollWidth - wrap.clientWidth); }
      function apply(animate){
        strip.style.transition = animate ? 'transform .35s cubic-bezier(.32,.72,0,1)' : 'none';
        strip.style.transform = 'translateX(' + (-x) + 'px)';
      }
      function snap(){
        var items = [...strip.children];
        var target = x;
        var best = Infinity;
        for (var i = 0; i < items.length; i++){
          var left = items[i].offsetLeft - PAD;           // align card's left edge to the padding
          if (Math.abs(left - x) < best){ best = Math.abs(left - x); target = left; }
        }
        x = Math.min(Math.max(0, target), maxShift());
        apply(true);
      }
      wrap.addEventListener('pointerdown', function(e){
        dragging = true; startX = e.clientX; baseX = x;
        try { wrap.setPointerCapture(e.pointerId); } catch(err){}
        apply(false);
      });
      wrap.addEventListener('pointermove', function(e){
        if (!dragging) return;
        x = Math.min(Math.max(0, baseX - (e.clientX - startX)), maxShift());
        apply(false);
      });
      function up(){ if (!dragging) return; dragging = false; snap(); }
      wrap.addEventListener('pointerup', up);
      wrap.addEventListener('pointercancel', up);
      wrap.style.touchAction = 'pan-y';
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  /* ============================== (D) Mobile footer reflow (tablet & below) ============================== */
  /* Requested mobile order: newsletter → logo/subtext/social → accordions
       (Shop Women's, Shop Men's, Help center, Resources, Your Account) → legal links.
     The 5 menus live across TWO sibling footer sections (footer-secondary + footer-tertiary) that
     share no flex parent, and the logo block sits BELOW them in source order — so the reorder is
     impossible with CSS alone. We RELOCATE the real nodes (appendChild MOVES, never clones → one
     link set in the DOM, zero SEO duplication) into a self-contained accordion list mounted in the
     secondary footer, and fully reverse every move above 1024px. The desktop DOM is byte-identical
     to untouched. Below the fold, so the on-load reflow has negligible CLS. */
  (function mobileFooter(){
    var MQ = '(max-width:1024px)';
    var built = false;
    var moves = [];                 // {node, parent, next} captured BEFORE each move; replayed in reverse to restore
    var host = null;                // the accordion list we create

    /* Styles ship WITH this module (the footer is JS-built, so its CSS lives next to the JS that
       builds it). Injected once into <head>; everything is gated on body.nv-mfooter-on + ≤1024px
       so desktop is never affected. */
    var FOOTER_CSS = "@media (max-width:1024px){"
      + "body.nv-mfooter-on .footer-secondary .footer__card-grid,"
      + "body.nv-mfooter-on .shopify-section-footer--tertiary .footer__card-grid{display:none!important;}"
      + "body.nv-mfooter-on .footer-secondary .footer__block.block-logo_with_text_NhJkWG{display:block!important;border:0!important;padding:0 0 1.6rem!important;margin:0!important;}"
      + ".nv-facc-host{display:flex;flex-direction:column;}"
      + ".nv-facc{border-top:1px solid rgba(0,0,0,.08);}"
      + ".nv-facc:last-child{border-bottom:1px solid rgba(0,0,0,.08);}"
      + ".nv-facc__btn{width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:1.6rem 0;background:none;border:0;cursor:pointer;text-align:left;font:inherit;color:#000;}"
      + ".nv-facc__label{font-weight:600!important;opacity:1!important;}"
      + ".nv-facc__chev{flex:0 0 auto;width:1.4rem;height:1.4rem;background-color:currentColor;transition:transform .25s ease;"
      +   "-webkit-mask:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 9L12 15L18 9' stroke='black' stroke-width='1.5'/%3E%3C/svg%3E\") center/contain no-repeat;"
      +   "mask:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 9L12 15L18 9' stroke='black' stroke-width='1.5'/%3E%3C/svg%3E\") center/contain no-repeat;}"
      + ".nv-facc.is-open .nv-facc__chev{transform:rotate(180deg);}"
      + ".nv-facc__panel{max-height:0;overflow:hidden;transition:max-height .28s ease;}"
      + ".nv-facc__inner{padding:0 0 1.4rem;}"
      + ".nv-facc__inner .footer__menu{display:flex!important;flex-direction:column;gap:1rem;margin:0 0 1rem;}"
      + ".nv-facc__inner .footer__menu:last-child{margin-bottom:0;}"
      + "body.nv-mfooter-on .shopify-section-footer--tertiary .footer__bottom-bar{display:flex!important;flex-wrap:wrap!important;justify-content:center!important;align-items:center!important;gap:1.2rem 2rem!important;text-align:center;}"
      + "}";
    function injectCSS(){
      if (document.getElementById('nv-mfooter-css')) return;
      var st = document.createElement('style');
      st.id = 'nv-mfooter-css';
      st.textContent = FOOTER_CSS;
      document.head.appendChild(st);
    }

    function move(node, newParent){
      if (!node || !newParent) return;
      moves.push({ node: node, parent: node.parentNode, next: node.nextSibling });
      newParent.appendChild(node);
    }
    function menusFrom(sel){ return [].slice.call(document.querySelectorAll(sel)); }
    function titleText(sel, fallback){
      var el = document.querySelector(sel);
      return (el && el.textContent.trim()) || fallback;
    }
    function buildAccordion(title, menuNodes){
      var acc = document.createElement('div');
      acc.className = 'nv-facc';
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'nv-facc__btn'; btn.setAttribute('aria-expanded', 'false');
      var label = document.createElement('span'); label.className = 'nv-facc__label'; label.textContent = title;
      var chev = document.createElement('span'); chev.className = 'nv-facc__chev'; chev.setAttribute('aria-hidden', 'true');
      btn.appendChild(label); btn.appendChild(chev);
      var panel = document.createElement('div'); panel.className = 'nv-facc__panel';
      var inner = document.createElement('div'); inner.className = 'nv-facc__inner';
      panel.appendChild(inner);
      for (var i = 0; i < menuNodes.length; i++) move(menuNodes[i], inner);
      btn.addEventListener('click', function(){
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? (inner.scrollHeight + 'px') : '';
      });
      acc.appendChild(btn); acc.appendChild(panel);
      return acc;
    }

    function build(){
      if (built) return;
      var sec = document.querySelector('.footer-secondary .footer__container') ||
                document.querySelector('.footer-secondary');
      if (!sec) return;             // footer group not on this page
      host = document.createElement('div'); host.className = 'nv-facc-host';

      // 1) logo/subtext/social block → top of the secondary footer
      var logoBlock = document.querySelector('.shopify-section-footer--tertiary .footer__block.block-logo_with_text_NhJkWG') ||
                      document.querySelector('.footer__block[class*="logo_with_text"]');
      if (logoBlock) move(logoBlock, sec);
      sec.appendChild(host);

      // 2) accordions (order is the requested mobile order)
      var cats = [
        { t: titleText('.block-menu_khhkwG .footer__title', "Shop Women's Clothing"),
          m: menusFrom('.block-menu_khhkwG .footer__menu, .block-menu_6FCNTm .footer__menu, .block-menu_CgerDm .footer__menu') },
        { t: titleText('.block-menu_rXqdNx .footer__title', "Shop Men's Clothing"),
          m: menusFrom('.block-menu_rXqdNx .footer__menu, .block-menu_LdNVYf .footer__menu, .block-menu_YrV3bb .footer__menu') },
        { t: titleText('.block-menu_double_Dgx4DE .footer__title:not(.second-menu)', 'Help center'),
          m: menusFrom('.block-menu_double_Dgx4DE .footer__menu:not(.second-menu)') },
        { t: titleText('.block-menu_wWXAxP .footer__title', 'Resources'),
          m: menusFrom('.block-menu_wWXAxP .footer__menu') },
        { t: titleText('.block-menu_double_Dgx4DE .footer__title.second-menu', 'Your Account'),
          m: menusFrom('.block-menu_double_Dgx4DE .footer__menu.second-menu') }
      ];
      for (var i = 0; i < cats.length; i++){
        if (cats[i].m.length) host.appendChild(buildAccordion(cats[i].t, cats[i].m));
      }
      document.body.classList.add('nv-mfooter-on');
      built = true;
    }

    function teardown(){
      if (!built) return;
      for (var i = moves.length - 1; i >= 0; i--){
        var m = moves[i];
        try { if (m.parent && m.parent.isConnected) m.parent.insertBefore(m.node, m.next); } catch (e){}
      }
      moves = [];
      if (host && host.parentNode) host.parentNode.removeChild(host);
      host = null;
      document.body.classList.remove('nv-mfooter-on');
      built = false;
    }

    function sync(){ if (window.matchMedia(MQ).matches) build(); else teardown(); }
    var t;
    function onResize(){ clearTimeout(t); t = setTimeout(sync, 150); }
    function boot(){ injectCSS(); sync(); window.addEventListener('resize', onResize, { passive: true }); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function(){ teardown(); sync(); });
  })();

  /* ============================== (C) Predictive search matches color tags ============================== */
  /* Products are tagged with their color labels (search index covers tags), but Shopify's
     predictive/suggest endpoint only searches tags when the request explicitly asks via
     resources[options][fields]. The theme doesn't, so the search drawer found nothing for
     "red". Append the fields option to every /search/suggest request (fetch + XHR). */
  (function searchTagFields(){
    var FIELDS = 'title,product_type,vendor,tag,variants.title,variants.sku';
    function fix(url){
      try {
        var u = new URL(url, location.origin);
        if (u.origin !== location.origin || u.pathname.indexOf('/search/suggest') === -1) return url;
        if (u.searchParams.has('resources[options][fields]')) return url;
        u.searchParams.set('resources[options][fields]', FIELDS);
        return u.toString();
      } catch (e){ return url; }
    }
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      if (typeof input === 'string'){ input = fix(input); }
      else if (input && input.url){ var f = fix(input.url); if (f !== input.url) input = new Request(f, input); }
      return origFetch.call(this, input, init);
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      if (typeof url === 'string') arguments[1] = fix(url);
      return origOpen.apply(this, arguments);
    };
  })();
})();
